import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Forms from "../../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../../Componets/Header";
import Loadercomponent from "../../../../../Componets/Loader";
import Formdata from "../../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../../Componets/Formcomponents/header";
import Bodycomponent from "../../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../../Componets/Formcomponents/title";
import JournalEntriesTable from "../../../../../Data/Forms/Accounting/ManualEntry/table";
import forms from "../../../../../Data/Forms/Accounting/ManualEntry/forms";
import headers from "../../../../../Data/Forms/Accounting/ManualEntry/headers";
import { create_manual_journal } from "../../../../../Controllers/Accounting/Services/manualJournalsService";

const ManualJournalForm = () => {
  let navigate = useNavigate();

  const [contra, setContra] = useState(false);
  const [errors, setErrors] = useState({});

  const getformdata = async (data) => {
    console.log("Form data changed:", data);
    /* if (typeof data.isContraEntry !== "undefined") {
      setContra(data.isContraEntry);
    } */
  };

  const [entries, setEntries] = useState([
    {
      id: "",
      account: "",
      type: "debit",
      amount: "",
      reference: "",
      description: "",
    },
    {
      id: "",
      account: "",
      type: "credit",
      amount: "",
      reference: "",
      description: "",
    },
  ]);

  const [documents, setDocuments] = useState([]);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);

  const focus = useRef([]);

  const validateEntries = (data) => {
    let newErrors = {};
    let validated = [];

    data.forEach((v, i) => {
      if (!v.account) {
        newErrors[`account${i}`] = "Account is required";
      } else if (v.amount <= 0) {
        newErrors[`amount${i}`] = "Amount must be greater than 0";
      } else {
        validated.push(v);
      }
    });

    setErrors(newErrors);

    const totalDebits = data
      .filter(entry => entry.type === "debit")
      .reduce((sum, entry) => sum + Number(entry.amount || 0), 0);

    const totalCredits = data
      .filter(entry => entry.type === "credit")
      .reduce((sum, entry) => sum + Number(entry.amount || 0), 0);

    console.log("Total Debits:", totalDebits, "Total Credits:", totalCredits);

    if (Math.abs(totalDebits - totalCredits) > 0.001) {
      toast.error("Total debits must equal total credits");
      return { status: false, data: validated };
    }

    return { status: Object.keys(newErrors).length === 0, data: validated };
  };

  const formdata = async (data) => {
    if (data?.status) {
      const validateEntriesResult = validateEntries(entries);

      if (validateEntriesResult?.status) {
        setButtonLoader(true);

        try {
          const journalEntry = {
            date: data.data.date,
            description: data.data.description,
            referenceNumber: data.data.referenceNumber,
            documents: documents.map((doc) => ({
              filename: doc.filename,
              originalName: doc.originalName,
              url: doc.url,
              type: doc.type,
              mimetype: doc.mimetype,
              size: doc.size,
            })),
            entries: entries.map((entry) => ({
              account: entry.account,
              amount: parseFloat(entry.amount),
              type: entry.type,
              reference: entry.reference?.trim() || "",
              description: entry.description?.trim() || "",
            })),
            status: "posted",
            createdBy: localStorage.getItem("userId"),
            is_contra: contra,
          };

          const result = await create_manual_journal(journalEntry);

          if (result?.success) {
            navigate(-1);
            toast.success(
              result?.message || "Journal entry created successfully!"
            );
            setButtonLoader(false);
          } else {

            setButtonLoader(false);
            if (result?.status_code == 403) {
              window.location.href = "/unauthorized";
            } else {
              toast.error(result?.message || "Failed to create journal entry");
            }
          }
        } catch (error) {
          console.error("Submission error:", error);
          toast.error(
            error?.response?.data?.message || "Failed to create journal entry"
          );
          setButtonLoader(false);
        }
      }
    }
  };

  const handleData = async (journalData) => {
    setLoader(false);
  };

  const fetchData = async () => {
    setLoader(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
          getformdata={getformdata}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Journal Entries"} />
            <Formdata>
              <Headercomponent index={0} name={"Entries"} required={true} />
              <JournalEntriesTable
                entries={entries}
                setEntries={setEntries}
                documents={documents}
                setDocuments={setDocuments}
                ref={focus}
                contra={contra}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default ManualJournalForm;
